// LOGIN
const API_BASE_URL = localStorage.getItem("baseUrl") || process.env.REACT_APP_BASE_URL
const TALENT_API_BASE_URL = localStorage.getItem("talentBaseUrl") || process.env.REACT_APP_TALENT_BASE_URL

export const Admin_API = {
  AUTH_API: process.env.REACT_APP_BASE_URL + "Auth/",

  // Branch API
  Branch_API: API_BASE_URL + "Branch/",

  // --------------------- for User Assignments ---------------------------------
  User_API: API_BASE_URL + "User/",
  UserRoleAssign_API: API_BASE_URL + "UserRoleAssign/",

  // Role API
  Role_API: API_BASE_URL + "Role/",

  // Rights API
  Rights_API: API_BASE_URL + "Rights/",

  //Department API
  Department_API: API_BASE_URL + "Department/",

  //Designation API
  Designation_API: API_BASE_URL + "Designation/",

  //Location API
  Location_API: API_BASE_URL + "Location/",
};
export const LIBRARY_API = {
  CODELIST_API: API_BASE_URL + "Codelist/",
  TEMPLATE_API: API_BASE_URL + "Template/",
}

// Setting
export const Setting_API = {
  // Setting API
  Setting_API: API_BASE_URL + "Setting/",
};

export const Settings_API = {
  // impact type API
  ImpactType_API: API_BASE_URL + "ImpactType/",

  // workflow API
  Workflow_API: API_BASE_URL + "Workflow/",

  // workflow API
  WorkflowLabel_API: API_BASE_URL + "WorkflowLabel/",

  // Client API
  Client_API: API_BASE_URL + "Client/",
};

export const MasterPeriod_API = {
  // Master Period API
  MasterPeriod_API: API_BASE_URL + "MasterPeriod/",
};
export const Aliquot_API = {
  // Master Period API
  Aliquot_API: API_BASE_URL + "Aliquot/",
};
export const MasterStudy_API = {
  // Master Period API
  Study_API: API_BASE_URL + "Study/",
};
export const Folder_API = {
  // Master Period API
  Folder_API: API_BASE_URL + "FolderWiseFile/",
};
export const AdverseEvent_API = {
  AdverseEvent_API: API_BASE_URL + "AdverseEvent/",
}
export const AdverseEventFollowup_API = {
  AdverseEventFollowup_API: API_BASE_URL + "AdverseEventFollowup/",
}
export const AdverseEventMedications_API = {
  AdverseEventMedications_API: API_BASE_URL + "AdverseEventMedications/",
}
export const AdverseEventAssessment_API = {
  AdverseEventAssessment_API: API_BASE_URL + "AdverseEventAssessment/",
}
export const TrainingGroup_API = {
  TrainingGroup_API: API_BASE_URL + "TrainingGroup/",
  Dropdown: API_BASE_URL + "TrainingGroup/Dropdown",
}

// Dashboard
export const Dashboard_API = {
  // Dashboard API
  Dashboard_API: API_BASE_URL + "Dashboard/",
};

export const Version_API = {
  // Version API
  Version_API: API_BASE_URL + "Version/",
};


export const Report_API = {
  // Version API
  Report_API: API_BASE_URL + "Report/",
};


// Zentix Talent External API (separate server)
export const Vista_API = {
  TrainingTypeDropDown: TALENT_API_BASE_URL + "TrainingTypeDropDown",
  TypeWiseCategoryDropDown: TALENT_API_BASE_URL + "TypeWiseCategoryDropDown",
  CategoryWiseTitleDropDown: TALENT_API_BASE_URL + "CategoryWiseTitleDropDown",
  TitleSelectAll: TALENT_API_BASE_URL + "TitleSelectAll",
  CheckConnection: TALENT_API_BASE_URL + "CheckConnection",
  TrainingStatus: TALENT_API_BASE_URL + "TrainingStatus",
};

// CRF
export const CRF_API = {
  // CRF API
  CRF_API: API_BASE_URL + "CRF/",
};

export const CRF_ASSIGNMENT_API = {
  MODULE_WISE_CRF: API_BASE_URL + "CRF/Assignment/",
  CATEGORY_ASSIGNMENT: API_BASE_URL + "CRF/CategoryAssignment/",
};
// Volunteer
export const VOLUNTEER_API = {
  // Volunteer API
  VOLUNTEER_API: API_BASE_URL + "volunteer/",
  SCREENING_API: API_BASE_URL + "Screening/",
  STUDY_SCREENING_API: API_BASE_URL + "StudyScreening/",
  LAB_TESTS_API: API_BASE_URL + "StudyLabTest/",
  ICF_API: API_BASE_URL + "ICF/",
  VOLUNTEER_ENROLLMENT_API: API_BASE_URL + "VolunteerEnrollment/",
  VOLUNTEER_ASSIGNMENT_API: API_BASE_URL + "VolunteerAssignment/",
  VOLUNTEER_CHECKLIST_API: API_BASE_URL + "VolunteerChecklistAnswer/",
  VOLUNTEER_CHECKLIST_CONFIGURE_API: API_BASE_URL + "VolunteerChecklist/",
  VOLUNTEER_ATTACHMENT_API: API_BASE_URL + "attachment/",
  VOLUNTEER_TEST: API_BASE_URL + "volunteerAlcoholTest/",
};

export const VOLUNTEER_STUDY_DASHBOARD_API = {
  VOLUNTEER_STUDY_DASHBOARD_API: API_BASE_URL + "VolunteerStudyDashboard/",
};

export const SUBJECT_API = {
  ADD_SUBJECT: API_BASE_URL + "Subject/"
}

// Study
export const Study_API = {
  // Study API
  Study_API: API_BASE_URL + "Study/",
  ICF_API: API_BASE_URL + "Icf/",
  ICF_SELECT: API_BASE_URL + "Icf/",
  CHECKLIST_SELECTALL : API_BASE_URL + "SubjectChecklist/",
  SUBJECT_CRF_SELECTALL : API_BASE_URL + "SubjectCRF/",
  SUBJECT_CHECKLIST_CONFIGURE_API: API_BASE_URL + "SubjectChecklist/",

};

// Site
export const SITE_API = {
  // Site API
  Site_API: API_BASE_URL + "site/",
};

export const STUDY_LITE_API = {
  // Site API
  STUDY_LITE_API: API_BASE_URL + "StudyLite/",
};

export const MasterCheckList_API = {
  // Master ICF API
  MasterCheckList_API: API_BASE_URL + "Checklist/",
  ChecklistType_API: API_BASE_URL + "Checklisttype/",
};

export const Workflow_API = {
  // workflow API
  Workflow_API: API_BASE_URL + "Workflow/",
};
export const Sponsor_API = {
  // Sponsor API
  Sponsor_API: API_BASE_URL + "Sponsor/",
};

export const IP_API = {
  IP_API: API_BASE_URL + "Pharmacy/Inventory/",
  ACCEPTANCE_API: API_BASE_URL + "Pharmacy/Acceptance/",
};

export const LINE_CLEARANCE_API = {
  LINE_CLEARANCE_API: localStorage.getItem("baseUrl") + "Pharmacy/LineClearance/",
};

export const PHARMACY_REPORTS_API = {
  REPORT: API_BASE_URL + "Pharmacy/SummaryReports/",
}

export const RETENTION_API = {
  RETENTION_API: API_BASE_URL + "Pharmacy/Retention/",
};

export const DISPOSAL_API = {
  DISPOSAL_API: API_BASE_URL + "Pharmacy/Disposal/",
};

export const TRANSFER_API = {
  TRANSFER_API: API_BASE_URL + "Pharmacy/Transfer/",
};

export const DAILY_ACCOUNTABILITY_API = {
  DAILY_ACCOUNTABILITY_API: API_BASE_URL + "Pharmacy/DailyAccountability/",
};

export const DISPENSING_API = {
  DISPENSING_API: localStorage.getItem("baseUrl") + "Pharmacy/Dispensing/",
};

export const RETURNS_ACCOUNTABILITY_API = {
  RETURNS_ACCOUNTABILITY_API: API_BASE_URL + "Pharmacy/ReturnsAccountability/",
};

export const DOSING_SCHEDULE_API = {
  DOSING_SCHEDULE_API: API_BASE_URL + "DosingSchedule/",
};

export const PHARMACY_LEDGER_API = {
  PHARMACY_LEDGER_API: API_BASE_URL + "PharmacyLedger/",
}

export const ACTUAl_COUNT_API = {
  ACTUAL_COUNT_API: API_BASE_URL + "Pharmacy/PhysicalCount/",
}

export const SUBJECTCHECKIN_API = {
  SUBJECTCHECKIN: API_BASE_URL + "SubjectCheckin/",
};

export const SUBJECTCHECKOUT_API = {
  SUBJECTCHECKOUT: API_BASE_URL + "SubjectCheckout/",
};
export const TIMEPOINTS_API = {
  TIMEPOINTS_API: API_BASE_URL + "TimePoints/",
};

export const SUBJECTDETAILS_API = {
  SUBJECTDETAILS_API: API_BASE_URL + "SubjectDetail/",
  SUBJECT_PERIOD_INFO_API: API_BASE_URL + "SubjectPeriodInfo/",
};

export const SUBJECT_LABEL_API = {
  SUBJECT_LABEL_API: API_BASE_URL + "SubjectLabel/",
  SUBJECT_LABEL_HISTORY_API: API_BASE_URL + "SubjectLableHistory/",
};

export const REPRINT_LABEL_API = {
  REPRINT_LABEL_API: API_BASE_URL + "RePrintHistory/",
};

export const VACUTAINER_LABEL_API = {
  VACUTAINER_LABEL_API: API_BASE_URL + "VacutainerLabel/",
  VACUTAINER_LABEL_HISTORY_API: API_BASE_URL + "VacutainerHistory/",
}
export const CRYOVIAL_LABEL_API = {
  CRYOVIAL_LABEL_API: API_BASE_URL + "CryovialLabel/",
  CRYOVIAL_LABEL_HISTORY_API: API_BASE_URL + "CryovialLabelHistory/",
};
export const PRINT_REPORT_API = {
  PRINT_REPORT_API: API_BASE_URL + "PrintReport/",
};
export const SESSION_API = {
  SESSION_API: API_BASE_URL + "AccessioningSession/",
  SCAN_SAMPLE_COLLECTION_API: API_BASE_URL + "ScanSampleCollection/",
  SCAN_SAMPLE_SEPERATION_API: API_BASE_URL + "ScanSampleSeperation/",
  SAMPLE_COLLECTION_TIME_API: API_BASE_URL + "SampleCollectionTime/",
};
export const DESIGN_API = {
  DESIGN_API: API_BASE_URL + "StudyDesign/",
};

export const STUDY_RANDOMIZATION_API = {
  STUDY_RANDOMIZATION: API_BASE_URL + "StudyRandomization/",
};


export const TRAINING_GROUP_ASSIGN_TRAINING_API = {
  INSERT: API_BASE_URL + "TrainingGroupAssignTraining/Insert",
  SELECT_ALL: API_BASE_URL + "TrainingGroupAssignTraining/SelectAll",
  DELETE: API_BASE_URL + "TrainingGroupAssignTraining/Delete",
};

export const STUDY_PARTICIPANTS_API = {
  INSERT: API_BASE_URL + "StudyParticipants/Insert",
  SELECT_ALL: API_BASE_URL + "StudyParticipants/SelectAll",
  DELETE: API_BASE_URL + "StudyParticipants/Delete",
};


export const STUDY_PARTICIPATE_TRAINING_API = {
  SELECT_ALL: API_BASE_URL + "StudyParticipantsTraining/SelectAll",
  UPDATE_STATUS: API_BASE_URL + "StudyParticipantsTraining/UpdateTrainingStatus",
  TRAINING_HISTORY: API_BASE_URL + "StudyParticipantsTraining/TrainingHistorySelectAll",
};

export const AUDIT_API = {
  AUDIT_API: API_BASE_URL + "Audit/",
};

export const DISPENSING_LABEL_API = {
  PHARMACY_DISPENSING_SUBJECT_DETAILS_API: API_BASE_URL + "PharmacyDispensingSubjectDetails/",
  DISPENSING_LABEL_API: API_BASE_URL + "DispensingLabel/",
  DISPENSE_LABEL_HISTORY_API: API_BASE_URL + "DispenseLabelHistory/",
};

export const ICARD_LABEL_API = {
  SUBJECT_ID_CARD_HISTORY_API: API_BASE_URL + "SubjectIdCardHistory/",
};

export const AMBULATORY_VISIT_API = {
  AMBULATORY_VISIT_API: API_BASE_URL + "AmbulatoryVisit/",
  AMBULATORY_SUBJECT_ASSIGNMENT_API: API_BASE_URL + "AmbulatoryVisitSubjectAssignment/",
  AMBULATORY_VISIT_STATUS_HISTORY_API: API_BASE_URL + "AmbulatoryVisitStatusHistory/",
  AMBULATORY_VISIT_SUBJECT: API_BASE_URL + "AmbulatoryVisitSubject/",
}

export const AMBULATORY_VISIT_ACTIVITY_RESULT_API = {
  AMBULATORY_VISIT_ACTIVITY_RESULT_API: API_BASE_URL + "AmbulatoryVisitSubjectActivityResult/",
}

export const BLOCK_VOLUNTEER_API = {
  BLOCK_VOLUNTEER_API: API_BASE_URL + "volunteerBlock/",
}

export const DROPOUT_VOLUNTEER_API = {
  DROPOUT_VOLUNTEER_API: API_BASE_URL + "volunteerDropout/",
}

export const VOLUNTEER_TRANSFER_API = {
  VOLUNTEER_TRANSFER_API: API_BASE_URL + "volunteerTransfer/",
}

export const VERIFICATION_QUEUE_API = {
  VERIFICATION_QUEUE_API: API_BASE_URL + "VerificationQueue/",
  NOTIFICATION_COUNT_API: API_BASE_URL + "Notification/",
}

export const STUDY_COMPLETE_HISTORY_API = {
  HISTORY_API: API_BASE_URL + "StudyCompleteHistory/",
}

export const MODULE_MANAGEMENT_API = {
  MODULE_MANAGEMENT_API: API_BASE_URL + "ModuleManagement/",
}

export const DASHBOARD_API = {
  STUDY_DASHBOARD_API: API_BASE_URL + "StudyDashboard/",
  VOLUNTEER_DASHBOARD_API: API_BASE_URL + "Volunteer/Dashboard/",
}